export default function getURLParameter(name: string) {
    return new URLSearchParams(window.location.search).get(name);
}
